// src/api/axios.js
import axios from "axios";

const instance = axios.create({
  baseURL: "/", // 같은 도메인에서 쓰면 이대로 OK
  withCredentials: true, // 쿠키도 같이 보낼 거면 유지
});

// ====== 공통 Request 인터셉터: Authorization 헤더 붙이기 ======
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminAccessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ====== 401 응답 시 refresh-token 로직 (네가 만들어둔 거 살리기) ======
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

const refreshAccessToken = async () => {
  try {
    const response = await instance.post("/api/user/refresh-token");
    const newAccessToken =
      response.data?.data?.accessToken || response.data?.data;
    if (newAccessToken) {
      localStorage.setItem("adminAccessToken", newAccessToken);
    }
    return newAccessToken;
  } catch (err) {
    console.error("Failed to refresh access token:", err);
    throw err;
  }
};

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // 다른 요청들은 큐에 쌓아둠
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            if (token) {
              originalRequest.headers.Authorization = `Bearer ${token}`;
            }
            return instance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshAccessToken();
        processQueue(null, newToken);
        if (newToken) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
        }
        return instance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
